import { DetailedHTMLProps, InputHTMLAttributes } from 'react';
import classNames from 'classnames';

export const Toggle = (
  props: Omit<DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>, 'type'> & {
    'data-cy'?: string;
  },
) => {
  const handleClick = (event: React.MouseEvent | React.TouchEvent) => {
    event.preventDefault();

    if (!props.disabled && props.onClick) {
      props.onClick(event as any);
    }
  };

  return (
    <div
      className={classNames('toggle', { checked: props.checked, disabled: props.disabled })}
      style={props.checked && props.color ? { backgroundColor: props.color } : {}}
      onClick={handleClick}
      onTouchEnd={handleClick}
    >
      <input readOnly={true} type="checkbox" {...props} />
    </div>
  );
};
